/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import ThemeXContainer from 'Src/common/components/themeXContainer';
import history from 'Src/common/utilities/history';
import { isEmpty } from 'lodash';
import { IntlProvider } from 'react-intl';
import { Button } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import AlmasightsProvider from 'Src/common/providers/almasights';
import { PARENT_OBJECT_TYPES } from 'Src/common/constants';

import { getDashboardProps } from '../utils';
import Home from '../containers/home';
import Onboarding from '../containers/onboarding';
import Dashboard from '../containers/dashboard';

let i18Messages = require('Data/en-US/event.json');
const commonI18Messages = require('Data/en-US/common.json');
const vfxMessages = require('Data/en-US/vfx.json');
const mentorshipMessages = require('Data/en-US/mentorship.json');

i18Messages = { ...commonI18Messages, ...vfxMessages, ...i18Messages, ...mentorshipMessages };

if (!isEmpty(window.i18nMetadata) && !isEmpty(window.i18nMetadata.common)) {
  i18Messages = { ...i18Messages, ...window.i18nMetadata.common };
}

if (!isEmpty(window.i18nMetadata) && !isEmpty(window.i18nMetadata.mentorship)) {
  i18Messages = { ...i18Messages, ...window.i18nMetadata.mentorship };
}

/**
 * Root
 */
function Root() {
  useEffect(() => {
    const loader = document.getElementById('root-loader');
    if (loader) {
      loader.parentNode.removeChild(loader);
    }
  }, []);

  return (
    <IntlProvider locale="en" messages={i18Messages}>
      <AlmasightsProvider
        parentObject={{
          type: PARENT_OBJECT_TYPES.MENTORSHIP,
          id: window?.programDetails.id,
          name: window?.programDetails.name,
        }}>
        <Router history={history}>
          <ThemeXContainer
            showHeroBanner
            isLoaded
            heroBannerImage={window.programDetails.cover_image || window.defaultBannerImage}
            redirectLink="/mentorship"
            showHeader
            userData={window.userData}
            showLoginButton
            {...getDashboardProps()}>
            <Switch>
              <Route exact path="/mentorship/onboarding" component={Onboarding} />
              <Route path="/mentorship/mentors" component={Dashboard} />
              <Route path="/mentorship/connections" component={Dashboard} />
              <Route path="/mentorship/settings" component={Dashboard} />
              <Route path="/mentorship" component={Home} />
            </Switch>
            <If condition={window.isSiteAdmin && window.isUserAuthenticated}>
              <div className="mentorship-admin-floating-button">
                <Button icon={<SettingOutlined />} className="arc-floating-fixed-bottom-btn" href="/admin/mentorship">
                  Admin Actions
                </Button>
              </div>
            </If>
          </ThemeXContainer>
        </Router>
      </AlmasightsProvider>
    </IntlProvider>
  );
}

export default Root;
